import Vue from 'vue'

Vue.directive('numberOnly', {
	inserted: function(el, binding, vNode) {
		var _dc_ = binding.value
		// 根据包装单位 判断小数位数
		if (binding.value) {
			if (Number.isInteger(binding.value)) {
				// Nothing
			} else {
				_dc_ = getPackageNumber(binding.value) || 0
			}
		}
		// if (!_dc_) {
		//     return;
		// }
		var _ic_ = binding.arg
		var _abs_ = binding.modifiers || {}
		var ___decimal_count___ = _dc_ == 0 ? 0 : _dc_ || 4
		var ___int_count___ = _ic_ < 1 ? 1 : _ic_ || 10
		var init_value = el.__vue__.value || ''
		var oDiv = el //当前元素
		var self = this //上下文

		el.inputHandler = e => {
			const input = e.target
			if (___decimal_count___ == 0) {
				//整数
				let regExp = ''
				if (_abs_.abs) {
					regExp = '^[0-9]?\\d{0,' + ___int_count___ + '}$'
				} else {
					regExp = '^[\\+\\-]?\\d{0,' + ___int_count___ + '}$'
				}
				if (!e.target.value.match(new RegExp(regExp))) {
					if (e.target.o_value) {
						e.target.value = e.target.o_value
					} else {
						e.target.value = init_value
					}
				} else {
					if (e.target.value.match(/^\.\d+$/)) e.target.value = 0 + e.value
					if (e.target.value.match(/^\.$/)) e.target.value = 0
					e.target.o_value = e.target.value
				}
				// if (e.target.value.length == 0) e.target.value = 0;
			} else {
				// 小数
				let regExp = ''
				if (_abs_.abs) {
					regExp =
						'^(?:[0-9]?\\d{0,' +
						___int_count___ +
						'}(?:\\.\\d{0,' +
						___decimal_count___ +
						'})?|\\.\\d{0,' +
						___decimal_count___ +
						'}?)?$'
				} else {
					regExp =
						'^(?:[\\+\\-]?\\d{0,' +
						___int_count___ +
						'}(?:\\.\\d{0,' +
						___decimal_count___ +
						'})?|\\.\\d{0,' +
						___decimal_count___ +
						'}?)?$'
				}

				if (!e.target.value.match(new RegExp(regExp))) {
					if (e.target.o_value) {
						e.target.value = e.target.o_value
					} else {
						e.target.value = init_value
					}
				} else {
					if (e.target.value.match(/^\.\d+$/)) e.target.value = 0 + e.target.value
					if (e.target.value.match(/^\.$/)) e.target.value = 0
					e.target.o_value = e.target.value
				}
				// if (e.target.value.length == 0) e.target.value = 0;
			}
			if (e.target.value.indexOf('+') == 0) {
				if (e.target.value.length == 1) {
					e.target.value.length == 0
				} else {
					e.target.value = e.target.value.substring(1)
				}
			}
			if (e.target.value.match(/^-?(0|[1-9]\d*)(\.\d+)?$/)) {
			} else {
				if (
					e.target.value &&
					!(e.target.value.indexOf('-') == 0 && e.target.value.length == 1) &&
					e.target.value.indexOf('.') != e.target.value.length - 1
				) {
					if (e.target.value.indexOf('-00') == 0) {
						e.target.value = '-' + Number(e.target.value)
					} else {
						e.target.value = Number(e.target.value)
					}
				}
			}

			input.value = e.target.value
			// alert(input.value)
			if (input.vNode) {
				// input.vNode.componentInstance.setCurrentValue(input.value)
				if (input.vNode.data.model) {
					input.vNode.data.model.callback(input.value)
				}
			}
		}

		let inputs = oDiv.querySelectorAll('input[type="text"]')
		for (let INPUT of inputs) {
			INPUT.pattern = '^-?[0-9]{1,' + ___int_count___ + '}(\\.[0-9]{0,' + ___decimal_count___ + '})?$'
			INPUT._num_value = Number(init_value) || 0
			INPUT.vNode = vNode
			INPUT.addEventListener('input', el.inputHandler)
		}
	},

	unbind: function(el, binding) {
		let oDiv = el //当前元素
		let self = this //上下文
		//el.removeEventListener('input', el.handler);
		// $('input', el).off('input', el.inputHandler)
		let inputs = el.querySelectorAll('input')
		for (let input of inputs) {
			input.removeEventListener('input', el.inputHandler)
		}
	}
})



// WEBPACK FOOTER //
// ./src/directives/index.js